module.exports = __webpack_public_path__ + "358b86881f313fd4aa92ae107121bf0b.svg";


//////////////////
// WEBPACK FOOTER
// ../src/images/avatars/Avatar 24.svg
// module id = 814
// module chunks = 0